/* eslint-disable import/no-extraneous-dependencies */
// polyfills for IE
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'fast-text-encoding';

import React from 'react';
import ReactDOM from 'react-dom';

import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import App from './App';
import { getPluginId } from './helpers';
import { ErrorBoundary } from './pages';
import filteredBugsnagErrorMessages from './constants/filteredBugsnagErrorMessages';

// Initialize Bugsnag without any global error handling
Bugsnag.start({
  apiKey: 'f82c255da2c5f11f36eff96871c639ea',
  plugins: [new BugsnagPluginReact()],
  autoTrackSessions: false,
  autoDetectErrors: false,
  onError: (event) => {
    const errorMessage = event?.originalError?.message;
    if (errorMessage && filteredBugsnagErrorMessages
      .some((filtered) => errorMessage.includes(filtered))) {
      return false;
    }
    return true;
  }
});

ReactDOM.render(
  <ErrorBoundary>
    <App pluginId={getPluginId()} class="app" />
  </ErrorBoundary>,
  document.getElementById(process.env.REACT_APP_ROOT_ID)
);
